export default function (initRequest) {
    const URL = process.env.REACT_APP_BASE_URL;
    const JSON = process.env.REACT_APP_JSON_URL;
    return {
        getBidInfoList: initRequest.des("获取招标信息列表").post("/bid/getBidInfoList"),
        addBidInfo: initRequest.des("新增招标信息").post("/bid/addBidInfo"),
        updateBidInfo: initRequest.des("修改招标信息").post("/bid/updateBidInfo"),

        getValidBidInfoList: initRequest.des("获取所有有效的招标信息").post("/bid/getValidBidInfoList"),

        getTenderInfoList: initRequest.des("获取投标信息列表").post("/bid/getTenderInfoList"),
        addTenderInfo: initRequest.des("新增投标信息").post("/bid/addTenderInfo"),
        updateTenderInfo: initRequest.des("修改投标信息").post("/bid/updateTenderInfo"),
        
        getBidWinningCompanyList: initRequest.des("获取中标公司信息").post("/bid/getBidWinningCompanyList"),
        getIndexPageInfo: initRequest.des("获取首页招标信息").post("/bid/getIndexPageInfo"),
        getHistoryBidInfoList: initRequest.des("获取历史招标信息").post("/bid/getHistoryBidInfoList"),

        getFilesList: initRequest.des("获取附件列表").get(JSON+"/json/filesList.json?temp="+ new Date().getTime()),

        uploadFile: initRequest.des("文件上传接口").upload(URL+"/bid/uploadFile"),

    }
}